import { QuestionBase } from './question-base';

/*

Sample:

new QuestionGroup({
  key: 'name',
  title: 'nouns.name',
  questions: [...],
  order: 1
}),

*/
export class QuestionArray extends QuestionBase<string> {
  controlType = 'array';
  title: string;
  error: string;
  hideError: boolean;

  constructor(options: {} = {}) {
    super({ ...options, hideLabel: true, isGroup: true });
    this.title = options['title'];
    this.error = options['error'];
    this.hideError = options['hideError'];
  }
}
